import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!isAnchor) return;
    event.preventDefault();
    document.getElementById(href.slice(1))?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full border-2 border-brand-coal bg-brand-lime px-3 py-3 text-center text-sm font-extrabold uppercase leading-tight tracking-wide text-brand-coal shadow-[4px_4px_0_#111111] transition duration-150 hover:-translate-y-0.5 hover:bg-[#9BE52B] focus:outline-none focus:ring-4 focus:ring-brand-lime/50 active:translate-x-0.5 active:translate-y-0.5 active:shadow-none sm:text-base ${className}`} data-id="element-31" data-mp="2tx05cz2flcxa">
      {children}
    </a>;
}